<template>
    <div class="hts-distributing__detail">
        <schedule-map
            v-if="showMap"
            :journey="selectedJourney"
            :show-location="showLocation"
            class="min-h-[50%]" />
        <div
            ref="journeySchedule"
            v-loading="vehicleLoading"
            class="hts-distributing__detail-info p-1 gap-1">
            <div class="flex-initial">
                <div class="float-right flex gap-3 align-middle items-center mt-1 mr-1">
                    <hts-form-input
                        v-model="search"
                        placeholder="Nhập biển số xe"
                        class="w-80 inline-block align-middle">
                        <template #prefix>
                            <hts-icons icon-name="hi-magnifying-glass-icon" />
                        </template>
                    </hts-form-input>

                    <hts-map-icon-location store-key="distributing" />
                    <hts-map-icon-map store-key="distributing" />
                    <!-- <hts-map-icon-journey /> -->
                </div>

                <div
                    :class="{ hidden: !showManualSelection }"
                    class="inline-block align-middle mt-1 mr-1">
                    <hts-form-button
                        color="info"
                        icon-name="hi-check-icon"
                        :outline="false"
                        @click="manualScheduleOpen">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                    <hts-form-button @click="manualScheduleCancel">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>

                <div class="inline-block align-middle mt-1 mr-1">
                    <h5>
                        Trạng thái chặng:
                    </h5>
                    <hts-select-option
                        v-model="searchStatus"
                        class="inline-block"
                        :items="items"
                        key-id="value"
                        key-label="label"
                        :clearable="false" />
                </div>

                <div class="inline-block align-middle mt-1 mr-1">
                    <hts-form-date
                        v-model="daterange"
                        type="date"
                        range
                        prop="daterange"
                        label="Từ - Đến" />
                </div>
            </div>

            <schedule-board
                ref="scheduleBoard"
                :loading="vehicleLoading"
                :show-manual-selection="showManualSelection"
                :search="search"
                :from="daterange[0]"
                :to="daterange[1]"
                :search-status="searchStatus"
                @item-click="handleItemClick"
                @selection-change="handleSelectionChange" />
        </div>
        <hts-modal v-model="manualInputVisible">
            <hts-form
                v-loading="manualInputLoading"
                :rules="manualRules"
                @submit="manualScheduleConfirm(false)">
                <div class="mb-5">
                    <hts-form-date
                        v-model="manualData.startAt"
                        label="Thời gian khởi hành dự kiến"
                        type="datetime"
                        time-format="HH:mm"
                        name="estimatedDepartureTime"
                        prop="startAt"
                        required
                        confirm />
                    <hts-form-select
                        v-model="manualData.startAtNodeId"
                        :items="manualData.locations"
                        name="estimatedDepartureLocation"
                        prop="startAtNodeId"
                        key-id="id"
                        label="Địa điểm khởi hành dự kiến"
                        required />
                </div>
                <div>
                    <hts-form-button
                        type="submit"
                        color="info"
                        icon-name="hi-check-icon"
                        :outline="false"
                        :loading="manualLoading">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                    <hts-form-button @click="manualInputVisible = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
        <hts-modal v-model="manualConfirmVisible">
            <div class="flex items-center text-lg text-orange-500">
                <hts-icons
                    icon-name="hi-exclamation-triangle-icon"
                    color="orange"
                    size="2xl" />
                <span>
                    Cảnh báo
                </span>
            </div>
            <div class="my-2">
                <template
                    v-for="(error, index) in manualErrors"
                    :key="index">
                    <p class="text-error-500">
                        {{ error }}
                    </p>
                </template>
            </div>
            <hts-form-button
                color="warning"
                icon-name="hi-check-icon"
                :outline="false"
                :loading="manualLoading"
                @click="manualScheduleConfirm(true)">
                {{ $t('labels.forceConfirm') }}
            </hts-form-button>
            <hts-form-button @click="manualConfirmVisible = false">
                {{ $t('labels.cancel') }}
            </hts-form-button>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import ScheduleBoard from './journey-schedule/board.vue'
import ScheduleMap from './journey-schedule/map.vue'

const { map } = $store()

const showMap = computed(() => {
  return map.getShowMap.distributing
})

const showLocation = computed(() => {
  return map.getShowLocation.distributing
})

const showJourey = computed(() => {
  return map.showJourney
})

const emits = defineEmits(['change'])
const { $eventBus } = useNuxtApp()
const selectedJourney = ref(undefined)
const journeySchedule: any = ref(null)
const scheduleBoard: any = ref(null)

const showManualSelection = ref(false)

const search = ref('')
const searchStatus = ref<Number | null>(null)
const daterange = ref(['', '']) // search chặng

const vehicleLoading = ref(true)
const vehicles = ref<any[]>([])
const vehicleLength = computed(() => vehicles.value.length)

const manualItem: any = ref(null)
const manualSelectedVehicle = ref(null)
const manualLoading = ref(false)
const manualErrors = ref<any[]>([])
const manualInputVisible = ref<boolean>(false)
const manualConfirmVisible = ref<boolean>(false)

onMounted(() => {
  getVehicles()
})

watch(
  () => search.value,
  (val: string) => {}
)

watch(
  () => showMap.value,
  (val: boolean) => {
    scheduleBoard.value && scheduleBoard.value.onResize()
  }
)

watch(
  () => showJourey.value,
  (val: boolean) => {
    scheduleBoard.value && scheduleBoard.value.onResize()
  }
)

const showBackdrop = () => {
  $eventBus.emit('global-backdrop-show', { target: journeySchedule.value, options: { closeable: false } })
}
const hideBackdrop = () => {
  $eventBus.emit('global-backdrop-hide')
}

const getVehicles = (skip: number | null) => {
  vehicleLoading.value = true
  $api($url.journey.getVehicles, { query: { skip: skip != null ? skip : vehicleLength.value } })
    .then(({ data }: any) => {
      const temp = (data?.value || {}).data || []
      if (Array.isArray(temp)) {
        vehicles.value = [...vehicles.value, ...temp]
      }

      scheduleBoard.value && scheduleBoard.value.setRows(vehicles.value)
      vehicleLoading.value = false
    })
    .catch(() => {
      vehicleLoading.value = false
    })
}

const manualSchedule = (item: any) => {
  if (!item) {
    return
  }

  scheduleBoard.value.setPreview(item)
  manualItem.value = item
  showManualSelection.value = true
  showBackdrop()
}
const manualScheduleCancel = () => {
  scheduleBoard.value.setPreview(null)
  deleteItem(manualItem.value)
  manualHide()
}

const manualInputLoading = ref(false)
const manualScheduleOpen = () => {
  manualInputVisible.value = true
  manualInputLoading.value = true
  $api($url.journey.schedule.getLocations, {
    query: {
      vehicleId: manualSelectedVehicle.value,
      timeIn: manualItem.value.timeIn,
      timeOut: manualItem.value.timeOut
    }
  }).then(({ data }) => {
    const tmp = data.value || {}
    manualData.locations = tmp.data || []
    manualInputLoading.value = false
  })
}
const manualRules = reactive({
  startAt: 'required',
  startAtNodeId: 'required'
})
const manualData = reactive({
  startAt: '',
  startAtNodeId: '',
  locations: []
})
const manualScheduleConfirm = (force: boolean = false) => {
  if (!manualItem.value) {
    return $toast().error('Bạn chưa chọn xe')
  }
  if (!manualSelectedVehicle.value) {
    return $toast().error('Bạn chưa chọn xe')
  }

  manualLoading.value = true
  manualErrors.value = []
  $api($url.journey.schedule.manual, { body: { force, journeyId: manualItem.value._id, vehicleId: manualSelectedVehicle.value, manualData } })
    .then(({ data }) => {
      const { success, errors } = data.value || {}
      if (success) {
        if (manualItem.value.vehicleTempId) {
          manualItem.value.vehicleId = manualSelectedVehicle.value
        } else {
          manualItem.value.vehicleTempId = manualSelectedVehicle.value
        }

        scheduleBoard.value.deleteItem(manualItem.value)
        scheduleBoard.value.setItem(manualSelectedVehicle.value, manualItem.value)
        manualConfirmVisible.value = false
        emits('change')
        manualHide()

        setTimeout(() => {
          getVehicles(0)
        }, 200)
      } else {
        manualErrors.value = errors
        manualConfirmVisible.value = true
      }
      manualLoading.value = false
    })
    .catch(() => {
      manualLoading.value = false
    })
}
const manualHide = () => {
  showManualSelection.value = false
  manualInputVisible.value = false
  manualSelectedVehicle.value = null
  scheduleBoard.value.clearSelection()
  hideBackdrop()
  scheduleBoard.value.setPreview(null)
}
const handleSelectionChange = (id: any, val: boolean) => {
  if (!scheduleBoard.value || !manualItem.value) {
    return
  }
  manualSelectedVehicle.value = id
  scheduleBoard.value.setItem(id, manualItem.value, true)
}

const handleItemClick = (item: any) => {
  selectedJourney.value = item
}

const selectJourney = (item: any) => {
  handleItemClick(item)
}

const getRows = () => {
  return scheduleBoard.value.getRows()
}

const addRow = (data: { [key: string]: any }) => {
  return scheduleBoard.value.addRow(data)
}

const getRowById = (id: string) => {
  return scheduleBoard.value.getRowById(id)
}

const addItems = (items: any[]) => {
  if (!Array.isArray(items)) {
    return
  }
  return scheduleBoard.value.addItems(null, items)
}

const setItem = (id: string, data: any, review: boolean = false) => {
  return scheduleBoard.value.setItem(id, data, review)
}
const deleteItem = (data: any) => {
  return scheduleBoard.value && scheduleBoard.value.deleteItem(data)
}

const updateAndAddItem = (id: string, data: any) => {
  return scheduleBoard.value.updateAndAddItem(id, data)
}

const items = [
  { name: $t('labels.all'), value: null },
  {
    name: 'Có xe dự kiến',
    value: 3,
    class: { '!bg-orange-400': true, '!text-black': true } // Màu cam (#FF9800)
  },
  {
    name: 'Có xe chính thức',
    value: 4,
    class: { '!bg-green-300': true, '!text-black': true } // Màu xanh lá cây (#4CAF50)
  },
  {
    name: 'Đang vận chuyển',
    value: 5,
    class: { '!bg-blue-300': true, '!text-black': true } // Màu xanh lá cây đậm (#388E3C)
  },
  {
    name: 'Kết thúc chặng',
    value: 6,
    class: { '!bg-gray-300': true, '!text-black': true } // Màu xám (#9E9E9E)
  }
]
defineExpose({ manualSchedule, getRows, getRowById, addItems, setItem, deleteItem, updateAndAddItem, addRow, selectJourney })
</script>
